import React, { useEffect, useState } from 'react';
import Header from '../components/shared/Header';
import AppointmentDetails from './AppointmentDetails';
import Button from '../components/shared/Button';
import '../styles/global.css';
import DatePickerComponent from './DatePickerComponent';
import PreferredOptometristSelector from './PreferredOptometristSelector';
import { useApp } from '../context/appContext'
import toast from 'react-hot-toast';
import { postHoldAppointment } from '../services/postHoldAppointment'
import { getStaff } from '../services/getStaff';
import { fbApiUrl } from "./shared/facebooktrack_config";  
import errorIcon from '../assets/icons/error.svg';
import { getAssetUrl, haversineDistance } from '../utils/lib';


const steps = [
  { name: 'Select the location', link: 'listing', isActive: true },
  { name: 'Appointment Details', link: 'date-picker', isActive: true },
  { name: 'Confirm Details', isActive: false }
];


const DatePickerScreen = () => {

  
  const [allStaff, setAllStaff] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state
  const { form, setForm, setCurrentPage } = useApp();
  const [loading_button, setLoading_button] = useState(false);
  const [submissionFailed, setSubmissionFailed] = useState(false);

  const handleForm = async (e) => {
    if(!form.date || !form.testId || !form.time) {
      toast.error("Please select all required fields")
      return
    }

    e.preventDefault();
    setLoading_button(true);

    if (!fbApiUrl) {
      console.error("Error: fbApiUrl is not defined!");
    } 
    else {
      try{
     
        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const clientIp = ipData.ip; // Extracted IP Address

        // Get User Agent
        const userAgent = navigator.userAgent;
        
        const data = {
          data: [
            {
              event_name: "Date Time Confirm",
              event_time: Math.floor(Date.now() / 1000),
              user_data: {
                client_ip_address: clientIp,
                client_user_agent: userAgent,
              },
              action_source: "website",
              custom_data: {
                appointment_date: form.date,
                appointment_time: form.time,
              },
            },
          ],
          test_event_code: "TEST58912",
        };
      
        const response = await fetch(fbApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
    
        const result = await response.json();
      }
      catch (error) {
        console.error("Error sending data to Facebook API:", error);
      }
    }
    

    const res1 = await postHoldAppointment(form)
    if(res1?.data) {
      const res = res1?.data;
      setForm((prevForm) => ({
        ...prevForm,
        appointmentId: res.Id
      }));
      setLoading_button(false);
      setSubmissionFailed(false);
      setCurrentPage("form")
    }
    else{
      setLoading_button(false);
      setSubmissionFailed(true);
      // toast.error(res1.message || "Unfortunately the time slot you requested is no longer available. Please choose another.");

    }
  }


  useEffect(() => {
    if (submissionFailed) {
      // Delay a bit to make sure the element is rendered
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth"
        });
      }, 100); // 100ms delay to ensure rendering
    }
  }, [submissionFailed]);


  useEffect(() => {
    if(!form.location) setCurrentPage("map")

    const fetchStaff = async () => {
      const staff = await getStaff(form?.location?.Id)
      setAllStaff(staff)
    }

    fetchStaff()
  }, [form.location, setCurrentPage, form?.testId])

  const handleDatePickerLoading = (isLoading) => {
    setLoading(isLoading); // Set loader state based on DatePickerComponent status
  };

  return (
      <div className="main-container">
        {(loading) && (
          <div style={{position: 'fixed',height: '100%',width: '100%',top:0,background: 'rgba(0,0,0,0.4)',display: 'flex',justifyContent: 'center',alignItems: 'center',zIndex: 9999,}} className="loader-container">
            <div className="loader"></div>
          </div>
        )}
          <Header
            title="Book an Eye Test"
            steps={steps}
            subheading="Appointment Details"
            pageinfo={
              <>
                <div className="change-store-container">
                        {`${form?.location?.PIAB__Street__c}, ${form?.location?.PIAB__City__c} ${form?.location?.PIAB__State__c} ${form?.location?.PIAB__Postal_Code__c}`}
                    <div className="d-flex btn-container">
                        <button className="change-store" onClick={() => setCurrentPage("map")}>Change store
                        </button>
                    </div>
                </div>
              </>
            }
          />
          <AppointmentDetails/>
          <PreferredOptometristSelector staff={allStaff} />
          <DatePickerComponent onLoading={handleDatePickerLoading} />
          <div className="submit-button-container">
            <button className="custom-button datepicker-continue" disabled={loading_button} onClick={handleForm}>{loading_button ? <span className="loader_datepicker_screen"></span> : "Continue"}</button>
          </div>
          {submissionFailed && (
            <div className='error-button-div-datepicker'>
              <img className="error-icon" src={getAssetUrl(errorIcon)} alt="Error Icon" /><p>This appointment time is no longer available. Please select a new date/time</p>
            </div>
          )}
      </div>
  
    );
};

export default DatePickerScreen;
